export enum Locale {
  En = 'en',
}
export const DEFAULT_LOCALE =
  window?.Shopify?.locale || window.boostSDAppConfig?.generalSettings?.current_locale || Locale.En;
